<template>
  <div class="pt-4 bg-white project-info rounded-3xl">
    <h2 class="flex flex-row items-center justify-between gap-2 mt-2 text-2xl font-bold text-newColors-purple-third">
      <div class="flex items-center gap-1.5">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 9H21M7 3V5M17 3V5M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V8.2C21 7.07989 21 6.51984 20.782 6.09202C20.5903 5.71569 20.2843 5.40973 19.908 5.21799C19.4802 5 18.9201 5 17.8 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z"
            stroke="#8100D1"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M13 17L15 15M15 15L13 13M15 15H9" stroke="#8100D1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <span class="text-xl font-bold text-newColors-gray-content"> {{ translations.planned }}</span>
      </div>
      {{ plannedProjects }}
    </h2>
    <h2 class="flex flex-row items-center justify-between gap-2 mt-2 text-2xl font-bold text-newColors-orange-signatureA">
      <div class="flex items-center gap-1.5">
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.2623 9.24887H18.2623L19.2623 12.0987H9.89161C9.25654 12.0987 8.939 12.0987 8.67572 12.0254C7.96713 11.828 7.31075 11.0605 7.22571 10.3299C7.19411 10.0584 7.22492 9.86221 7.28654 9.46977C7.29824 9.39525 7.31414 9.3215 7.33415 9.24887M14.2623 9.24887H7.33415M14.2623 9.24887V3.24887H13.1194C12.443 3.24887 12.1048 3.24887 11.8024 3.34759C11.5348 3.43493 11.2887 3.57777 11.0801 3.76676C10.8443 3.98037 10.0979 4.93361 9.76234 5.52085L7.68396 8.51104C7.52694 8.7858 7.44842 8.92323 7.39295 9.06909C7.37051 9.1281 7.35089 9.18809 7.33415 9.24887M10.0801 9.46977V11.7489L8.4483 10.8802M8.4483 10.8802L7.26234 10.2489L8.14857 11.4828L8.4483 10.8802ZM8.4483 10.8802L8.76234 10.2489M18.2623 10.2489H16.0497L13.2623 10.7489L16.2738 11.4181M16.2738 11.4181L17.7623 11.7489L15.0236 11.5382M16.2738 11.4181L15.0236 11.5382M16.2738 11.4181L18.0351 11.2489M15.0236 11.5382L12.3438 11.3321M15.0236 11.5382L12.8306 11.7489L12.3438 11.3321M12.3438 11.3321L11.2623 11.2489M12.3438 11.3321L11.0786 10.2489M8.14852 2.98285L6.86754 2.15977C6.57932 1.98857 6.35916 1.86054 6.19099 1.76483C5.85137 1.57155 5.49188 1.46997 5.10339 1.51203C4.95714 1.52787 4.74648 1.58948 4.63678 1.68748C4.29863 1.98955 4.03298 2.63305 2.4999 5.4999L1.69319 7.01654C1.31361 7.73016 1.12382 8.08697 1.06482 8.4598C1.01264 8.78951 1.03435 9.1267 1.12838 9.44699C1.23471 9.80918 1.46869 10.1387 1.93664 10.7978L2.53096 11.6348M2.53096 11.6348L4.64857 11.4828L4.14759 9.98231L2.53096 11.6348ZM5.26233 19.2489C4.15776 19.2489 3.26233 18.3534 3.26233 17.2489C3.26233 16.1443 4.15776 15.2489 5.26233 15.2489H17.2976C18.4022 15.2489 19.2976 16.1443 19.2976 17.2489C19.2976 18.3534 18.4022 19.2489 17.2976 19.2489H5.26233Z"
            stroke="#E07300"
            stroke-width="1.72194"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>

        <span class="text-xl font-bold text-newColors-gray-content"> {{ translations.ongoing }}</span>
      </div>
      {{ ongoingProjects }}
    </h2>
    <h2 class="flex flex-row items-center justify-between gap-2 mt-2 text-2xl font-bold text-newColors-green-primary">
      <div class="flex items-center gap-1.5">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 10.3333L8.46154 13L14 7M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#0B8454" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        <span class="text-xl font-bold text-newColors-gray-content"> {{ translations.finished }}</span>
      </div>
      {{ finishedProjects }}
    </h2>
    <h2 class="flex flex-row items-center justify-between gap-2 mt-2 text-2xl font-bold text-newColors-gray-content">
      <div class="flex items-center gap-1.5">
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.5 6.99999L7 9.99999H11L9.5 13M17 9.99999C17 14.4611 11.54 17.6937 9.64142 18.683C9.43607 18.79 9.33339 18.8435 9.19095 18.8712C9.08 18.8928 8.92 18.8928 8.80905 18.8712C8.66661 18.8435 8.56393 18.79 8.35858 18.683C6.45996 17.6937 1 14.4611 1 9.99999V6.21759C1 5.41808 1 5.01833 1.13076 4.6747C1.24627 4.37113 1.43398 4.10027 1.67766 3.88552C1.9535 3.64243 2.3278 3.50207 3.0764 3.22134L8.4382 1.21067C8.6461 1.13271 8.75005 1.09373 8.85698 1.07827C8.95184 1.06457 9.04816 1.06457 9.14302 1.07827C9.24995 1.09373 9.3539 1.13271 9.5618 1.21067L14.9236 3.22134C15.6722 3.50207 16.0465 3.64243 16.3223 3.88552C16.566 4.10027 16.7537 4.37113 16.8692 4.6747C17 5.01833 17 5.41808 17 6.21759V9.99999Z"
            stroke="#2C2827"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>

        <span class="text-xl font-bold text-newColors-gray-content"> {{ translations.total }}</span>
      </div>
      {{ totalProjects }}
    </h2>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'

const props = defineProps({
  translations: {
    type: Object,
    default: () => {}
  },
  items: {
    type: Object,
    default: () => {}
  }
})

// Data
const plannedProjects = computed(() => props.items?.filter((item) => item.projectState === 'Planned').length)
const ongoingProjects = computed(() => props.items?.filter((item) => item.projectState === 'Ongoing').length)
const finishedProjects = computed(() => props.items?.filter((item) => item.projectState === 'Finished').length)
const totalProjects = computed(() => props.items?.length)
</script>

<style scoped></style>
